var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import { ButtonSetting, ButtonOption, ButtonSecondary } from '../Button/';
import { ButtongroupOptions } from "../Buttongroup/";
import { Dropdown } from '../Dropdown/';

var SettingsOptions = (_temp2 = _class = function (_Component) {
    _inherits(SettingsOptions, _Component);

    function SettingsOptions() {
        var _temp, _this, _ret;

        _classCallCheck(this, SettingsOptions);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onSettings = function (event) {
            event.preventDefault();
            var id = _this.props.id;


            if (_this.props.onClick) {
                _this.props.onClick();
            } else if (_this.props.onSettings) {
                _this.props.onSettings(id);
            }
        }, _this.onChange = function (name, value) {

            if (_this.props.onChange) {
                _this.props.onChange(name, value);
            }
        }, _this.renderOption = function (option, index) {
            var name = _this.props.name;
            var type = option.type,
                icon = option.icon,
                title = option.title,
                value = option.value,
                onClick = option.onClick;


            var label = title || option.label || option.value;

            if (type == "secondary") {
                return React.createElement(ButtonSecondary, { key: index, label: label, onClick: onClick });
            }

            if (onClick) {
                return React.createElement(ButtonOption, { key: index, icon: icon, label: label, value: value, selected: _this.props.value === value, onClick: onClick });
            }

            return React.createElement(ButtonOption, { key: index, icon: icon, label: label, value: value, selected: _this.props.value === value, onClick: function onClick() {
                    return _this.onChange(name, value);
                } });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    SettingsOptions.prototype.render = function render() {
        var _props = this.props,
            id = _props.id,
            expanded = _props.expanded,
            type = _props.type,
            name = _props.name,
            value = _props.value,
            options = _props.options;


        if (expanded) {
            return React.createElement(
                React.Fragment,
                null,
                React.createElement(ButtonSetting, _extends({}, this.props, { label: value, expanded: expanded, onClick: this.onSettings })),
                React.createElement(
                    Dropdown,
                    { align: 'right' },
                    React.createElement(
                        ButtongroupOptions,
                        { name: name, dataType: type },
                        options.map(this.renderOption)
                    )
                )
            );
        }

        return React.createElement(ButtonSetting, _extends({}, this.props, { label: value, expanded: expanded, onClick: this.onSettings }));
    };

    return SettingsOptions;
}(Component), _class.defaultProps = {
    expanded: false,
    options: []
}, _temp2);


export default SettingsOptions;